module.exports = __webpack_public_path__ + "static/media/greenhouse2Step9-6.d7483eb5.gif";